import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Injectable()
export class AutoRedemptionFeatureGuard {
  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService,
  ) {}

  canActivate(): boolean {
    if (!this.featureFlagService.isAutoRedemptionEnabled) {
      this.router.navigate(['/orders']);
      return false;
    }

    return true;
  }
}
